export var ColorCodedState;
(function (ColorCodedState) {
    ColorCodedState["neutral"] = "neutral";
    ColorCodedState["success"] = "success";
    ColorCodedState["positive"] = "positive";
    ColorCodedState["attention"] = "attention";
    ColorCodedState["warning"] = "warning";
    ColorCodedState["alert"] = "alert";
    ColorCodedState["error"] = "error";
    ColorCodedState["disabled"] = "disabled";
})(ColorCodedState || (ColorCodedState = {}));
